import { useField } from "formik";
import React from "react";
import { Dropdown, Form, Label } from "semantic-ui-react";

const auths = [
  { text: "Disabled", key: "DISABLED", value: "DISABLED" },
  { text: "API Key", key: "KEY", value: "KEY" },
  { text: "API Key & Secret", key: "KEY_SECRET", value: "KEY_SECRET" },
  { text: "Basic Authentication", key: "BASIC_AUTH", value: "BASIC_AUTH" },
  { text: "OAUTH", key: "OAUTH", value: "OAUTH" },
];

const AuthenticationSelect = ({ label, onChange, ...props }: any) => {
  const [field, meta, helpers] = useField(props);
  return (
    <Form.Field>
      <label>{label}</label>
      <Dropdown
        name={field.name}
        defaultValue={field.value}
        fluid
        search
        selection
        options={auths}
        placeholder='Select Auth Type'
        onChange={(event, { value }) => {
          helpers.setValue(value);
          onChange(value);
        }}
      />
      {meta.error && (
        <Label basic color='red' pointing>
          {meta.error}
        </Label>
      )}
    </Form.Field>
  );
};

export default AuthenticationSelect;
